<script setup>
    import { defineEmits, defineExpose, inject } from 'vue';
    import { useAgreementDetailStore } from '@/stores/modal/agreementDetailStore';
    import utils from '@/commonProject/helpers/utils';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // ----------------------------
    // 同意済み規定詳細
    // ----------------------------
    const agreementDetailStore = useAgreementDetailStore();

    /**
     * 同意済み規定詳細取得処理
     * @param API_URL
     * @param queryParam
     * @returns なし
     */
    async function getAgreementDetail(API_URL, queryParam) {
        const response = await agreementDetailStore.getAgreementDetailAction(API_URL, queryParam);
        if (true !== response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // 親側実装必須処理
    // ----------------------------
    const emit = defineEmits(['agreementDetailModal:close']);
    function close() {
        // 親画面のモーダル非表示処理を呼び出す
        emit('agreementDetailModal:close');
    }

    /**
     * 親画面から規定詳細モーダルを開くイベントが実行された場合の処理。
     * @param {String} API_URL HTMLファイルタグが生成されている座標を取得する。
     * @param {String} regulationPk 規定PK
     * @param {String} regulationHistPk 規定履歴PK
     * @returns なし
     */
    async function openModal(trg, regulationPk, regulationHistPk) {
        let queryParam = {
            RegulationPk: regulationPk,
        };

        // 規定履歴PKが設定されている場合はAPIのクエリパラメーターの条件に含める。
        if (!utils.isNullEmpty(regulationHistPk)) {
            queryParam['RegulationHistPk'] = regulationHistPk;
        }

        await getAgreementDetail(trg, queryParam);

        // モーダルのHTML要素を取得する。
        const elm1 = document.querySelector('#modalUserTermsDetail .modalContents');

        // モーダルの縦スクロールを先頭に戻す。
        elm1.scrollTop = 0;
    }
    defineExpose({
        openModal,
    });
</script>

<style></style>

<template>
    <article id="modalUserTermsDetail" class="modal userInfoConfirm" :style="{ display: 'block' }">
        <h3 class="textCenter">{{ $t('agreementDetail.parts.modalTitle1') }}</h3>
        <section class="modalContents" style="height: calc(100% - 145px);">
            <div class="regulationBox" style="height: auto; margin-top: 15px;">
                <span class="regulationDate">{{ agreementDetailStore.RegulationDt }}</span>
                <span class="regulationTitle">{{ $t('agreementDetail.parts.dl1') }}</span>
                <div class="regulationBody" style="min-height: 743px">{{ agreementDetailStore.RegulationContent }}</div>
                <!-- <textarea class="regulationBody" disabled v-model="agreementDetailStore.RegulationContent" /> -->
            </div>
        </section>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal backModal" @click="close">
                        {{ $t('message.common.parts.back') }}
                    </button>
                </li>
            </ul>
        </section>
    </article>
</template>
